import { render, staticRenderFns } from "./final.vue?vue&type=template&id=145a96e5&scoped=true&"
import script from "./final.vue?vue&type=script&lang=js&"
export * from "./final.vue?vue&type=script&lang=js&"
import style0 from "./final.vue?vue&type=style&index=0&id=145a96e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a96e5",
  null
  
)

export default component.exports